import Dashboard from "./Dashboard";
import Links from "./Links";
import LinkBuilder from "./Links/Builder";
// Analytics list page is hidden — analytics is viewed per-link from the Links
// page (the chart icon on each card → analytics/:id detail below).
// import AnalyticsList from "./Analytics";
import AnalyticsDetail from "./Analytics/Detail";
import QR from "./QR";
import Domains from "./Domains";
import Campaigns from "./Campaigns";
import CampaignDetail from "./Campaigns/Detail";
import LandingPages from "./Pages";
import LandingPageBuilder from "./Pages/Builder";
import Branding from "./Branding";
import WhiteLabel from "./WhiteLabel";

// Inner routes are *relative* to /:companyId/:planId — react-router v6
// resolves these against the parent splat from src/router/routes.tsx.
const routes = [
  {
    key: "dashboard",
    route: "dashboard",
    component: <Dashboard />,
  },
  {
    key: "links",
    route: "links",
    component: <Links />,
  },
  {
    key: "links-new",
    route: "links/new",
    component: <LinkBuilder />,
  },
  {
    key: "links-edit",
    route: "links/:id/edit",
    component: <LinkBuilder />,
  },
  // Analytics list page hidden for now (almost identical to Links). Users open
  // analytics per-link from the Links page. Detail route stays active.
  // {
  //   key: "analytics",
  //   route: "analytics",
  //   component: <AnalyticsList />,
  // },
  {
    key: "analytics-detail",
    route: "analytics/:id",
    component: <AnalyticsDetail />,
  },
  {
    key: "qr",
    route: "qr",
    component: <QR />,
  },
  {
    key: "domains",
    route: "domains",
    component: <Domains />,
  },
  {
    key: "branding",
    route: "branding",
    component: <Branding />,
  },
  {
    key: "white-label",
    route: "white-label",
    component: <WhiteLabel />,
  },
  {
    key: "campaigns",
    route: "campaigns",
    component: <Campaigns />,
  },
  {
    key: "campaigns-detail",
    route: "campaigns/:id",
    component: <CampaignDetail />,
  },
  {
    key: "landing-pages",
    route: "landing-pages",
    component: <LandingPages />,
  },
  {
    key: "landing-pages-new",
    route: "landing-pages/new",
    component: <LandingPageBuilder />,
  },
  {
    key: "landing-pages-detail",
    route: "landing-pages/:id",
    component: <LandingPageBuilder />,
  },
];

export default routes;
